<template>
  <section class="home-bed">
    <div class="img-bed">
      <black-bar :ifCanBack="false" title="开卡激活">
      </black-bar>
    </div>
    <img src="../assets/img/noAccess/icon_success.png"
         alt=""
         style="margin-top:4vh">
    <p>成功开通</p>
    <div class="line"></div>
    <div class="warning">
      使用提示：<br />
      1.一个用户1个手机当前只能使用一个武汉通SIM交通卡；<br />
      2.乘坐公交或地铁时，无需打开APP，直接将手机贴靠出口设备
      扫卡区域。
    </div>
    <div class="type"
         @click="goRouter('usePhone')">刷手机方式指导</div>
    <div class="btn"
         @click="goRouter('payIndex')">完成</div>

  </section>
</template>

<script>
import blackBar from '@/components/blackBar'
export default {
  name: 'openSuccess',
  data () {
    return {
      loading: true,
      num: 20
    }
  },
  components: {
    blackBar
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  methods: {
    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  text-align: center;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  // height: 320px;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
p {
  font-size: 40px;
  font-weight: 500;
  color: #333333;
  margin-top: 24px;
}
img {
  width: 100px;
  height: 100px;
}
.line {
  width: 92%;
  margin-left: 4%;
  border: 1px dashed #999999;
  margin-top: 60px;
}
.warning {
  width: 92%;
  line-height: 36px;
  margin-left: 4%;
  margin-top: 60px;
  text-align: left;
  font-size: 24px;
  font-weight: 400;
  color: #999999;
}
.type {
  width: 92%;
  margin-left: 4%;
  font-size: 28px;
  font-weight: 400;
  color: #4a8ef7;
  text-align: right;
  margin-top: 24px;
  line-height: 40px;
}
.btn {
  position: absolute;
  left: 0;
  bottom: 80px;
  width: 92%;
  margin-left: 4%;
  height: 98px;
  line-height: 98px;
  background: #4a8ef7;
  box-shadow: 0px 6px 20px 1px rgba(63, 138, 247, 0.2);
  border-radius: 49px 49px 49px 49px;
  font-size: 32px;
  font-weight: 400;
  color: #ffffff;
}
</style>
